import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraCTA = ({ slug }) => {
  const navigate = useNavigate();

  return (
    <div className="py-6 px-6 bg-gradient-to-br from-violet-950 to-slate-950 text-center relative overflow-hidden">
      <div className="max-w-xl mx-auto">
        <div className="text-lg lg:text-2xl mb-4">🌍</div>
        <h2 className="text-lg lg:text-xl text-cyan-200 font-bold tracking-tight mb-2">
          Imagine every locality having its own digital exhibition.
        </h2>
        <p className="text-sm lg:text-lg text-purple-200 mb-6">
          Join the movement strengthening local economies worldwide.
        </p>

        <div className="flex flex-col lg:flex-row gap-2 justify-center">
          <button
            onClick={() => navigate("/nabora/merchant")}
            className="px-4 py-2 border border-white/60 bg-gray-600 text-white hover:bg-white/10 rounded-xl font-bold text-sm lg:text-lg transition-all"
          >
            Start as Merchant 🚀
          </button>

          <button
            onClick={() => navigate("/nabora/organiser")}
            className="px-4 py-2 border border-white/60 bg-gray-600 text-white hover:bg-white/10 rounded-xl font-bold text-sm lg:text-lg transition-all"
          >
            Join as Organiser
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 right-0 text-6xl opacity-10 pointer-events-none">
        💜
      </div>
    </div>
  );
};

export default NaboraCTA;
